<template>
  <v-app id="login">
    <v-main>
      <v-container class="fill-height" fluid
        :style="{ background: 'url(' + require('@/assets/bg.jpg') + ') center center / cover' }">
        <v-row align="center" justify="center">
          <v-overlay z-index="0" opacity="0.6" absolute></v-overlay>
          <v-col cols="12" sm="8" md="3" lg="3" style="z-index: 1">
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="@/assets/logo.png" alt="Logo" width="120" height="120">
                </div>
                <v-form ref="authForm" v-model="validations.authForm.valid" v-if="!isSignup" @input="checkFormValidity">
                  <v-text-field v-model="authForm.username" :rules="validations.authForm.username"
                    :error-messages="customErrors.authForm.username" :disabled="loading" @keypress.enter="login()"
                    @input="checkFormValidity" label="Nombre de usuario" append-icon="mdi-account-circle" required
                    autofocus></v-text-field>

                  <v-text-field v-model="authForm.password" :rules="validations.authForm.password"
                    :error-messages="customErrors.authForm.password" :disabled="loading" @keypress.enter="login()"
                    @input="checkFormValidity" type="password" label="Contraseña" append-icon="mdi-key-variant"
                    required></v-text-field>
                </v-form>
                <div class="blue--text text-center">
                  <v-hover v-slot="{ hover }">
                    <span
                      class="blue--text"
                      :style="{ cursor: 'pointer', 'text-decoration': hover ? 'underline' : 'none' }"
                      @click="$router.push({ name: 'Password' })"
                    >
                    ¿Olvidaste tu contraseña?
                    </span>
                  </v-hover>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="login()" :loading="loading" :disabled="!isFormValid" color="primary" block>
                  Acceder
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import MobileDetect from 'mobile-detect'
import { mapGetters } from 'vuex/dist/vuex.common.js'
import UserService from '@/services/UserService'
export default {
  data: () => ({
    loading: false,
    isSignup: false,
    md: new MobileDetect(navigator.userAgent),
    isFormValid: false,

    // formulario de autenticación
    authForm: {
      username: null,
      password: null
    },

    // errores
    customErrors: {
      authForm: {
        username: [],
        password: []
      }
    },

    // temas
    themes: [
      {
        text: 'Light',
        value: 'light',
        colors: [
          '#ffffff', '#f5f5f5', '#c0c0c0'
        ]
      }
      /* {
        text: 'Dark',
        value: 'dark',
        colors: [
          '#424242', '#616161', '#757575'
        ]
      },
      {
        text: 'Blue',
        value: 'blue',
        colors: [
          '#bbdefb', '#64b5f6', '#1e88e5'
        ]
      },
      {
        text: 'Green',
        value: 'green',
        colors: [
          '#a5d6a7', '#66bb6a', '#388e3c'
        ]
      },
      {
        text: 'Red',
        value: 'red',
        colors: [
          '#ff5252', '#ff1744', '#d50000'
        ]
      } */
    ]
  }),

  computed: {
    validations () {
      return {
        authForm: {
          valid: true,
          username: [
            v => !!v || 'Debe proporcionar un correo electrónico.',
            v => /.+@.+\..+/.test(v) || 'Debe proporcionar un correo electrónico válido.'
          ],
          password: [
            v => !!v || 'Debe proporcionar una contraseña.'
          ]
        }
      }
    },
    // getters y setters de los campos del formulario
    ...mapGetters(['CURRENT_USER'])
  },

  methods: {
    checkFormValidity () {
      // Esta función evalúa directamente si hay valores en ambos campos
      this.isFormValid = !!this.authForm.username && !!this.authForm.password
    },

    async login () {
      this.loading = true
      this.$refs.authForm.validate()

      // Usar isFormValid en lugar de validations.authForm.valid
      if (this.isFormValid) {
        const error = await this.$store.dispatch('LOGIN', this.authForm)
        this.loading = false
        if (error === null) {
          // Obtener datos frescos del usuario con getMe()
          try {
            const userResponse = await UserService.getMe()
            const userData = userResponse.data.data

            // Aplicar el tema después de la autenticación exitosa
            const newTheme = localStorage.getItem('theme')
            if (newTheme) {
              this.$vuetify.theme.dark = newTheme === 'dark'
              if (newTheme !== 'dark' && newTheme !== 'light') {
                const theme = this.themes.find(theme => theme.value === newTheme)
                if (theme) {
                  this.$vuetify.theme.themes.light.primary = theme.colors[1]
                  this.$vuetify.theme.themes.light.secondary = theme.colors[0]
                  this.$vuetify.theme.themes.light.accent = theme.colors[2]
                }
              }
            } else if (!newTheme) {
              // Aplicar tema "Light" por defecto
              const theme = this.themes.find(theme => theme.value === 'light')
              this.$vuetify.theme.themes.light.primary = theme.colors[1]
              this.$vuetify.theme.themes.light.secondary = theme.colors[0]
              this.$vuetify.theme.themes.light.accent = theme.colors[2]
            }

            // Determinar redirección basado en datos frescos del usuario
            if (userData.roles.includes('admin') || userData.roles.includes('colaborator') || userData.dealer.is_colaborador) {
              this.$router.push({ name: 'User' })
            } else if (userData.dealer?.balance?.subscription_status !== 'active' &&
              userData.dealer?.balance?.subscription_status !== 'trialing') {
              this.$router.push({ name: 'Payment' })
            } else if (userData.dealer?.balance?.subscription_status !== 'active' &&
              userData.dealer?.balance?.subscription_status !== 'trialing' &&
              userData.dealer?.balance?.current_period_end < Math.floor(Date.now() / 1000) &&
              ['logistics', 'sales', 'manager'].some(role => userData.roles.includes(role))) {
              this.$router.push({ name: 'Suscripción expirada' })
            } else if (userData.dealer?.balance?.subscription_status !== 'active' &&
              userData.dealer?.balance?.subscription_status !== 'trialing' &&
              userData.dealer?.balance?.current_period_end < Math.floor(Date.now() / 1000) &&
              userData.roles.includes('manager')) {
              this.$router.push({ name: 'Payment' })
            } else if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl)
            } else if (this.md.mobile()) {
              this.$router.push({ name: 'Escaneo' })
            } else {
              this.$router.push({ name: 'Vehiculo' })
            }
          } catch (meError) {
            console.error('Error al obtener datos del usuario:', meError)
            // Fallback al comportamiento anterior si falla la petición a getMe()
            if (this.CURRENT_USER.roles.includes('admin') || this.CURRENT_USER.roles.includes('colaborator')) {
              this.$router.push({ name: 'User' })
            } else if (this.CURRENT_USER.dealer?.balance?.subscription_status !== 'active' &&
              this.CURRENT_USER.dealer?.balance?.subscription_status !== 'trialing') {
              this.$router.push({ name: 'Payment' })
            } else if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl)
            } else if (this.md.mobile()) {
              this.$router.push({ name: 'Escaneo' })
            } else {
              this.$router.push({ name: 'Vehiculo' })
            }
          }
        } else {
          this.authForm.password = null
          let { data, status } = error
          if (status === 422) {
            // mostrando los error de validación en los campos correspondientes
            data.forEach(el => {
              this.customErrors.authForm[el.field].push(el.message)
            })
          } else {
            // mostrando el error al usuario en una notificación
            this.$toast.error('Ocurrió un error al intentar acceder')
          }
        }
      } else {
        this.loading = false
      }
    }
  },

  mounted () {
    // Verificar campos al iniciar el componente (para autocompletado)
    this.$nextTick(() => {
      // Esperar a que el autocompletado pueda ocurrir
      setTimeout(() => {
        this.checkFormValidity()
      }, 500)
    })
  }
}
</script>

<style scoped></style>
